var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnetoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 16h8c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5h-8C4.673 0 4 .673 4 1.5v13c0 .827.673 1.5 1.5 1.5zM5 1.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-13z",
    fill: "#605E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.438 5H15V1h.438c.315 0 .562.26.562.594v2.812c0 .333-.247.594-.563.594h.001z",
    fill: "#AE4BD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.438 10H15V6h.438c.315 0 .562.26.562.594v2.812c0 .333-.247.594-.563.594h.001z",
    fill: "#9332BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.438 15H15v-4h.438c.315 0 .562.26.562.594v2.812c0 .333-.247.594-.563.594h.001z",
    fill: "#7719AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15h8a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1z",
    fill: "#7719AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.417 10.896V6.443h.085l3.981 3.989.059-.001V6.057",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnetoc);
export default __webpack_public_path__ + "static/media/onetoc.d12fa23aeabb88ee094cacc98557fbca.svg";
export { ForwardRef as ReactComponent };